angular.module('country', ['core', 'user'])
    .constant('CountryConst', {
        eventUpdate: 'country.updated'
    })
    .factory('Country', function ($resource) {
        return $resource('/crm/api/country/:id', {}, {
            list: {method: 'GET', isArray: false},
            update: {method: 'PUT'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/country/autocomplete'}
        })
    })
    .service('CountryService', function ($rootScope, modals, Country, CountryConst) {
        this.edit = entity => {
            modals.open('app/country/edit-modal.html', 'CountryDialogController', angular.copy(entity), {size: 'md'}, "$ctrl")
        }
        this.add = () => {
            let entity = {
                active: true,
                id: null,
                regions: []
            }
            return this.edit(entity)
        }
        this.remove = item => {
            modals.confirmDelete(item.name, () => Country.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(CountryConst.eventUpdate)))
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('countryList', {
            parent: 'app',
            url: '/country?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'countryList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (Country, $stateParams) => Country.list(angular.copy($stateParams)).$promise
            }
        })
    })
